<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Skapa tågvändning
      </v-card-title>

      <v-card-text class="mt-2">
        <TurnaroundTrainNumberFields>
          <TurnaroundLocationField />
        </TurnaroundTrainNumberFields>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="createPending">
          Skapa tågvändning
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import TurnaroundTrainNumberFields from './TurnaroundForm/TurnaroundTrainNumberFields'
import TurnaroundLocationField from './TurnaroundForm/TurnaroundLocationField'

export default {
  name: 'TurnaroundCreateModal',

  components: {
    TurnaroundTrainNumberFields,
    TurnaroundLocationField
  },

  data: () => ({
    required,
    valid: true,
    createPending: false
  }),

  created() {
    this.$store.set(
      'turnaround/model@event_uuid',
      this.$store.get('event/selectedUUID')
    )
  },

  computed: {
    model: sync('turnaround/model')
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.createPending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateTurnaroundInput!) {
            createTurnaround(payload: $payload) {
              turnaround_uuid
            }
          }
        `,
        variables: {
          payload: {
            ...this.model,
            checked: true
          }
        }
      })

      this.createPending = false
      this.$store.commit('turnaround/create', {
        ...this.model,
        checked: true
      })
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('turnaround/resetModel')
      this.$emit('close')
    }
  }
}
</script>
